import { Injectable } from "@angular/core";
import { AppConfigService } from "../AppConfigService";
import { AuthState, IdentityAuthService } from "./identity-auth.service";
import { firstValueFrom, Subject } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdentityClient, SiteConfiguration, UserInfo } from "../api_identity/api";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _user?: UserInfo;

  public get User() {
    return this._user;
  }
  public set User(user: UserInfo | undefined) {
    if (this._user !== user) {
      this._user = user;
      this.UserSubject.next(user);
    }
  }

  public get isSignedIn() {
    return !!this.User;
  }

  public UserSubject = new Subject<UserInfo | undefined>();

  public onUserChanged() {
    return this.UserSubject.asObservable();
  }


  static getUserFromStorage(): UserInfo | undefined {
    let user = localStorage.getItem('user');
    if (user) {
      let userObj =  JSON.parse(user);
      return UserInfo.fromJS(userObj);
    }
    return undefined;
  }

  static setUserToStorage(user?: UserInfo) {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }

  constructor(private client: IdentityClient, private authService: IdentityAuthService, private config: AppConfigService) {
    this.User = UserService.getUserFromStorage();

    this.authService.onStateChanged().subscribe((state: AuthState) => {
      if (state == AuthState.LoggedIn) {
        this.getUserInfo().then((userInfo) => {
          console.log(userInfo);
          this.User = userInfo
          UserService.setUserToStorage(userInfo);
        }).catch((error) => {
          console.log(error);
        });
      } else if (state == AuthState.LoggedOut) {
        this.User = undefined;
        UserService.setUserToStorage(undefined);
      }
    });
  }

  public async getUserInfo() {
    // Get config first, then use the SiteId to get user info
    return await firstValueFrom(
      this.config.getConfig().pipe(
        switchMap((appConfig) => this.client.getUserInfo(appConfig.SiteId))
      )
    );
  }

  public IsInRole(role: string) {
    if (!this.User || !this.User.Roles) {
      return false;
    }
    return this.User.Roles.includes(role);
  }
}
